import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, assetUrl } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { parseTags } from "@/lib/libraryImages";

interface Props { open: boolean; onClose: () => void; fileId: string | null; url?: string | null; defaultName?: string; defaultTags?: string[] }

export function AddToLibraryDialog({ open, onClose, fileId, url, defaultName = "", defaultTags = [] }: Props) {
  const [name, setName] = useState(defaultName);
  const [tags, setTags] = useState(defaultTags.join(", "));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setName(defaultName); setTags(defaultTags.join(", ")); } }, [open, defaultName, defaultTags]);

  const save = async () => {
    if (!fileId) return;
    setBusy(true);
    try { await api.post("/library-images/from-file", { file_id: fileId, name, tags: parseTags(tags) }); toast.success("Added to the image library"); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="add-to-library-dialog">
        <DialogHeader><DialogTitle>Add to image library</DialogTitle></DialogHeader>
        {url && <img src={assetUrl(url) || ""} alt="" className="aspect-[16/10] w-full rounded-md object-cover" />}
        <div><Label className="text-xs">Name</Label><Input data-testid="add-to-library-name" className="mt-1" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Two-storey warm white roofline" /></div>
        <div><Label className="text-xs">Tags (comma separated)</Label><Input data-testid="add-to-library-tags" className="mt-1" value={tags} onChange={(e) => setTags(e.target.value)} placeholder="mockup, warm white, roofline" /></div>
        <Button data-testid="add-to-library-save-btn" disabled={busy || !fileId} onClick={save} className="w-full bg-blue-700 hover:bg-blue-800">{busy ? "Saving…" : "Add to library"}</Button>
      </DialogContent>
    </Dialog>
  );
}
